import { post } from "../helpers";

export const usersService = {
    login,
    logout,
    windowsAuthenticationLogin,
    loginWithSessionID,
    useLoginToken
};

const userLocalStorageKey = "GOP.user";
const api = "/api/loginws/";

function login(username, password) {
    return post(api, { Username: username, Password: password }).then(afterLogin);
}



function windowsAuthenticationLogin() {
    return post(`${api}windowsAuthenticationLogin`).then(afterLogin);
}

function loginWithSessionID(sessionID) {
    return post(`${api}loginWithSessionID`, { SessionID: sessionID }).then(afterLogin);
}

function useLoginToken(loginToken) {
    return post(`${api}useLoginToken`, { loginToken }).then(afterLogin);
}

function logout(clientOnly, sessionID) {
    if (clientOnly)
        logoutInternal();
    else
        return post(`${api}logout`, { SessionID: sessionID }).then(response => {
            logoutInternal();
            return response;
        });
}

function logoutInternal() {
    localStorage.removeItem(userLocalStorageKey);
}

function afterLogin(response) {
    if (response.IsLoggedIn)
        localStorage.setItem(userLocalStorageKey, JSON.stringify(response.UserInfo));
    return response;
}

export function userLookupItemTemplate(data, _, element) {
    var displayExpr = this.displayExpr || this._userOptions.displayExpr
    element.innerText = typeof (displayExpr) === "function" ? displayExpr(data) : data[displayExpr]

    element.parentElement.title = data.UserLoginName
}